"use client";

import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { cn } from "@/lib/utils";

import LangaugeDropDown from "@/components/navbar/components/LangaugeDropDown";
import { LinkButtonSimple } from "@/components/ui/button-simple";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [pastHero, setPastHero] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Check if scrolled past 64px for minimal header
      if (window.scrollY > 64) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      // Check if scrolled past hero section by its ID
      const heroSection = document.getElementById("landing-hero");
      const header = document.querySelector("header");
      if (heroSection && header) {
        const headerHeight = header.offsetHeight;
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight + headerHeight;
        setPastHero(window.scrollY > heroBottom);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={cn(
        "fixed left-1/2 z-20 w-full -translate-x-1/2 transform transition-all duration-300",
        pastHero ? "bg-white" : "bg-system-obsidian",
        scrolled ? "px-3 py-3 sm:px-5 md:px-7 md:py-5" : "px-4 py-4 sm:px-6 md:px-8 md:py-6",
        scrolled && !pastHero && "bg-opacity-75 backdrop-blur-[15px] backdrop-saturate-[180%]"
      )}
    >
      <div className="landing-container">
        <div className="flex items-center justify-between">
          <Link
            href="/"
            className={cn(
              "relative h-[24px] w-[111px] transition-transform duration-300 sm:h-[26px] sm:w-[118px] md:h-[34px] md:w-[155px]",
              scrolled && "scale-[85%]"
            )}
          >
            <Image
              src={pastHero ? "/logo-black.svg" : "/logo-white.svg"}
              alt="logo"
              fill
              className="object-contain"
              priority
            />
          </Link>

          <nav className="flex items-center justify-between gap-3 md:gap-6">
            <LinkButtonSimple href="#join-waitlist" className={"h-[32px] md:h-[30px]"}>
              Join now
            </LinkButtonSimple>
            {/* <LangaugeDropDown variant="white" /> */}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
